'use client';

import { useState, useEffect, useRef } from 'react';

export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const [isClient, setIsClient] = useState(false);
  const rafRef = useRef(null);
  const visibleRef = useRef(false);

  useEffect(() => {
    setIsClient(true);

    const updateVisibility = () => {
      rafRef.current = null;
      const nextVisible = window.scrollY > 300;
      if (nextVisible !== visibleRef.current) {
        visibleRef.current = nextVisible;
        setIsVisible(nextVisible);
      }
    };

    const onScroll = () => {
      if (rafRef.current) return;
      rafRef.current = requestAnimationFrame(updateVisibility);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', onScroll);
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
        rafRef.current = null;
      }
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  if (!isClient) {
    return null;
  }

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="backToTop"
          aria-label="Voltar ao topo"
        >
          ↑
        </button>
      )}
    </>
  );
} 